import { render, staticRenderFns } from "./PastAppointmentNotificationModal.vue?vue&type=template&id=65543abb&scoped=true&"
import script from "./PastAppointmentNotificationModal.vue?vue&type=script&lang=js&"
export * from "./PastAppointmentNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./PastAppointmentNotificationModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PastAppointmentNotificationModal.vue?vue&type=style&index=1&id=65543abb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65543abb",
  null
  
)

export default component.exports